// import SectionHead from '@/components/general/SectionHead';
// import styles from './styles.module.css';
// import FeatCard from './FeatCard';
// import MainIcons from '@/icons/main';
// import { useTranslations } from 'next-intl';
// import { FeatureSection } from '@/commonTypes';

// export function Features({
//   feat,
//   cardBg = 'white',
//   showNumber = false,
// }: {
//   feat?: FeatureSection;
//   gridClass?: string;
//   cardBg?: 'white' | 'lightGray';
//   showNumber?: boolean;
// }) {
//   return (
//     <section className={`${styles.section}`}>
//       <div className={styles.inner}>
//         <SectionHead
//           tag={feat?.kicker}
//           title={feat?.title}
//           text={feat?.sub}
//           wrapper={`${styles.head}`}
//           type={'section'}
//         />

//         <div className={`${`grid_${feat?.cards?.length}`}`}>
//           {feat?.cards?.map((f, index) => (
//             <FeatCard f={f} key={index} bg={cardBg} showNumber={showNumber} index={index} />
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// ===============
import SectionHead from '@/components/general/SectionHead';
import styles from './styles.module.css';
import FeatCard from './FeatCard';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import { FeatureSection } from '@/commonTypes';
import { ReactNode } from 'react';

type FeaturesProps = {
  feat?: FeatureSection;
  cardBg?: 'white' | 'lightGray';
  showNumber?: boolean;
  children?: (props: {
    f: any;
    index: number;
    bg: 'white' | 'lightGray';
    showNumber: boolean;
  }) => ReactNode;
  showMore?: boolean;
  className?: string;
  position?: 'center' | 'normal';
  headClass?: string;
  href?: string;
  buttonClass?: string;
};

export function Features({
  feat,
  cardBg = 'white',
  showNumber = false,
  children,
  showMore = false,
  className = '',
  position = 'center',
  headClass = '',
  href,
  buttonClass = '',
}: FeaturesProps) {
  return (
    <section className={`${styles.section} ${className}`}>
      <div className={styles.inner}>
        <SectionHead
          tag={feat?.kicker}
          title={feat?.title}
          text={feat?.sub}
          wrapper={`${styles.head} ${headClass}`}
          type="section"
          showMore={showMore}
          position={position}
          href={href}
          buttonClass={`${buttonClass}`}
        />

        <div className={`grid_${feat?.cards?.length}`}>
          {feat?.cards?.map((f: any, index: number) =>
            children ? (
              children({
                f,
                index,
                bg: cardBg,
                showNumber,
              })
            ) : (
              <FeatCard
                key={index}
                f={f}
                bg={cardBg}
                showNumber={showNumber}
                index={index}
                fill={f?.fill}
              />
            ),
          )}
        </div>
      </div>
    </section>
  );
}
